<template>
    <div>
        <div id="help" class="bg-white p-30 content" v-html="articleDetail.content"></div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        data() {
            return {}
        },
        computed: {
            ...mapState({
                articleDetail: state => state.main.article.info
            })
        },
        created() {
            this.$store.dispatch('main/getArticleList', {id: '10005'})
        }
    };
</script>
<style lang="less">
    #help {
        p {
            margin: 10px;
        }
    }
</style>
